import { getCookie, setCookie } from "./utils/cookies";
import { v4 as uuidv4 } from "uuid";

export const UUID_COOKIE_NAME = "whoop-experiment-uuid";

export const fetchVariant = async ({ filters, name }) => {
  const body = filters ? JSON.stringify(filters) : undefined;
  const cookieValue = getCookie(UUID_COOKIE_NAME);
  const uuid = uuidv4();

  const stickinessValueFromCookies = cookieValue
    ? decodeURIComponent(cookieValue)
    : uuid;

  try {
    const variantResponse = await fetch(
      `${process.env.REACT_APP_API_URL}/experiment-service/v1/experiments/name/${name}/variant`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": "en",
          "X-WHOOP-Installation-Identifier": stickinessValueFromCookies,
        },
        body,
      }
    );
    if (variantResponse.status !== 200) {
      return null;
    }

    const variant = await variantResponse.text();

    if (variant) {
      setCookie(UUID_COOKIE_NAME, stickinessValueFromCookies);
      return variant;
    }

    return null;
  } catch (error) {
    return null;
  }
};
